export default __webpack_public_path__ + "static/media/sport-city.3f19f536.png";